import React, { useState } from 'react';
import { default as SlickSlider } from 'react-slick';
import './style.css';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
function SampleNextArrow(props) {
  const { className, style, onClick } = props;

  return (
    <img
      src="/assets/images/slider/right.png"
      alt="slider-right"
      className={className + ' SampleNextArrow'}
      style={{ ...style }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src="/assets/images/slider/right.png"
      alt="slider-right"
      className={className + ' SamplePrevArrow'}
      style={{ ...style }}
      onClick={onClick}
    />
  );
}

const Slider = (props) => {
  const { subTitle, title, more, slidesToShow, responsive, items, arrows, rows } = props;
  let history = useHistory();
  let location = useLocation();
  const { t, i18n } = useTranslation();
  const [settings, setSetting] = useState({
    dots: false,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 5.8,
    initialSlide: 0,
    swipeToSlide: true,
    speed: 500,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: null,
    rows: 1,
  });
  const customResponsive = () => {
    let responsiveArray = [];
    responsive.map((item) => {
      responsiveArray.push({
        breakpoint: item.maxWidth,
        settings: {
          slidesToScroll: 1,
          slidesToShow: item.slidesToShow,
        },
      });
    });
    return responsiveArray;
  };

  // const settings = {
  //   dots: false,
  //   infinite: false,
  //   slidesToScroll: 1,
  //   slidesToShow: slidesToShow,
  //   initialSlide: 0,
  //   swipeToSlide: true,
  //   speed: 500,
  //   nextArrow: <SampleNextArrow />,
  //   prevArrow: <SamplePrevArrow />,
  //   responsive: responsive ? customResponsive() : null,
  //   rows: rows ? rows : 1,
  // };

  const changePath = (more) => {
    history.push(more);
  };
  React.useEffect(() => {
    if (slidesToShow && responsive) {
      setSetting({
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: slidesToShow,
        initialSlide: 0,
        swipeToSlide: true,
        speed: 500,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: responsive ? customResponsive() : null,
        rows: rows ? rows : 1,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responsive, rows, slidesToShow]);
  if (items() && items().length) {
    return (
      <div className="container">
        <div className="slider-header-container">
          <div className="slider-header-left">
            <div className="slider-header-sub-title">{subTitle}</div>
            <div className="slider-header-title"> {title} </div>
          </div>
          <div className="slider-header-right">
            {!!more && (
              <div
                className="slider-header-more"
                onClick={() => {
                  changePath(more);
                }}
              >
                {t('see-all')}
              </div>
            )}
          </div>
        </div>
        <br className="hide-on-mobile" />
        <br />
        <div className="slider-container">{settings !== undefined && <SlickSlider {...settings}>{items()}</SlickSlider>}</div>
      </div>
    );
  } else return <></>;
};

export default Slider;
